import React from 'react';

const weekdays = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'];
const weekend = ['DOM', 'SAB'];

interface Props {
    activeDays: string[] | undefined | never;
    weekOfMonth?: string;
}

const ScheduledWeekComponente: React.FC<Props> = (props) => {

    if (!props.activeDays || props.activeDays.length === 0) {
        return <span style={{ fontSize: '12px', color: '#888' }}>-</span>;
    }
    var Weekly = props.weekOfMonth ? props.weekOfMonth != "0" ? `${props.weekOfMonth}°` : "S" : "";
    return (
        <div style={{
            display: 'flex',
            gap: '4px',
            padding: '4px 0'
        }}>
            <span>  {Weekly}</span>
            {weekdays && weekdays.length > 0 && weekdays.map((dia, i) => {
                console.log(props.activeDays)
                const isActive = props.activeDays && props.activeDays.includes(dia) ? true : false;
                const isWeekend = weekend.includes(dia) ? true : false;
                return (
                    <span
                        key={i}
                        style={{
                            textTransform: 'lowercase',
                            fontSize: '10px',
                            fontWeight: 500  ,
                            borderRadius: '8px',
                            padding: '2px 8px',
                            backgroundColor: isActive ? '#b6fff2' : '#e0e0e0',
                            color: isActive ? '#1b1b1b' : '#777',
                            fontFamily: 'Segoe UI, sans-serif',
                            minWidth: '32px',
                            textAlign: 'center'
                        }}
                    >
                        {dia.toLowerCase()}
                    </span>
                );
            })}
        </div>
    );
};

export default ScheduledWeekComponente;
